<template>
  <el-dialog
    title="首页入口配置"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
  <el-table
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    stripe
    @selection-change="handleSelectionChange">
    <el-table-column
      type="selection"
      >
    </el-table-column>
    <el-table-column
      prop="deptName"
      label="学院名称"
      show-overflow-tooltip>
    </el-table-column>
  </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small"  @click="close">取 消</el-button>
      <el-button size="small" type="primary" @click="comfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import { getTicketDeptInfoVo, ticketDeptUpdate } from "@/api/resourceService"

export default {
  components: {},
  props: {
    dialogInfo: {
      type: Object,
      default: function () {
        return {
          show: false,
          uuid: null
        };
      },
    },
  },
  data() {
    return {
      tableData: [],
      selectDepts: [],
    };
  },
  created() {
    this.getDept();
  },
  activated() {},
  computed: {},
  methods: {
    getDept() {
      getTicketDeptInfoVo({
        uuid: this.dialogInfo.uuid
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data || []
          setTimeout(() => {
            this.tableData.forEach(item => {
              if (item.isSelected == 1) {
                this.$refs.multipleTable.toggleRowSelection(item, true);
              }
            });
          }, 200);
        }
      })
    },


    handleSelectionChange(selectRows) {
      this.selectDepts = selectRows;
    },


    comfirm() {
      let codeStr = this.selectDepts.map( o => o.deptLevelCode).join(',')
      ticketDeptUpdate({
        deptLevelCodes: codeStr,
        uuid: this.dialogInfo.uuid
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success(res.msg);
          this.close();
        }
      })
      
    },

    close() {
      this.$emit('closeDialog')
    },

  },
};
</script>
<style lang='scss' scoped>

/deep/ .el-table th.el-table__cell > .cell {
  padding-left: 17px;
}
</style>